/* LEGACY LIST, DON'T ADD ANY NEW FLAGS IN THIS LIST */

import { getFlag } from 'hb-react/shared/utils/launchDarkly';

export default ({
  flagBraintree3DSecureSca,
  flagBulkAdminInvitations,
  flagCdUniversalTags,
  flagDuplicateAdmin,
  flagMembershipsAddOn,
  flagMembershipsDonation,
  flagStanfordMessagingRequirements,
  testSomeFeatureFlag,
}) => ({
  flags: [
    'flagBraintree3DSecureSca',
    'flagBulkAdminInvitations',
    'flagCdUniversalTags',
    'flagCompaniesFacelift',
    'flagDuplicateAdmin',
    'flagGroupsHeaderFacelift',
    'flagMembershipsAddOn',
    'flagMembershipsDonation',
    'flagStanfordMessagingRequirements',
    'testSomeFeatureFlag',
  ],
  values: {
    payments: {
      braintreeSca: getFlag({ flagBraintree3DSecureSca }),
    },
    messaging: {
      stanfordRequirements: getFlag({ flagStanfordMessagingRequirements }),
    },
    contentDiscovery: {
      universalTags: getFlag({ flagCdUniversalTags }),
    },
    memberships: {
      donation: getFlag({ flagMembershipsDonation }),
      addOn: getFlag({ flagMembershipsAddOn }),
    },
    testSomeFeatureFlag: getFlag({ testSomeFeatureFlag }),
    admins: {
      adminInvitationsBo: getFlag({ flagBulkAdminInvitations }),
      duplicateAdminBo: getFlag({ flagDuplicateAdmin }),
    },
  },
});
